global.BaseUrl = 'https://admin.foodweb-robin.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-robin.ksoftpl.com';
